<template>
  <div class="app-container goods-meta-page">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        :placeholder="`${pageTitle}名称`"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="是否启用"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option label="启用" :value="1" />
        <el-option label="停用" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="resetFilter">重置</el-button>
      <el-button class="filter-item" type="primary" icon="el-icon-plus" @click="openAttrDialog()"
        >新增</el-button
      >
    </div>

    <el-table v-loading="listLoading" :data="list" size="small" border fit highlight-current-row>
      <el-table-column label="编号" prop="id" align="center" width="90" />
      <el-table-column :label="`${pageTitle}名称`" prop="name" align="center" min-width="160" />
      <el-table-column label="属性值" align="center" min-width="260">
        <template slot-scope="scope">
          <div v-if="scope.row.values && scope.row.values.length" class="value-tags">
            <el-tag
              v-for="item in scope.row.values"
              :key="item.id"
              size="mini"
              :type="item.status === 1 ? '' : 'info'"
            >
              {{ item.valueName }}
            </el-tag>
          </div>
          <span v-else class="muted">暂无属性值</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        prop="remark"
        align="center"
        min-width="160"
        show-overflow-tooltip
      />
      <el-table-column label="是否启用" prop="status" align="center" width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
            {{ scope.row.status === 1 ? "启用" : "停用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort" align="center" width="90" />
      <el-table-column label="创建时间" prop="ctdate" align="center" width="170">
        <template slot-scope="scope">{{ formatApiDate(scope.row.ctdate) }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="230" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="openAttrDialog(scope.row)">编辑</el-button>
          <el-button type="primary" size="mini" plain @click="openValueDrawer(scope.row)"
            >属性值</el-button
          >
          <el-button type="danger" size="mini" plain @click="removeAttr(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="attrForm.id ? `编辑${pageTitle}` : `新增${pageTitle}`"
      :visible.sync="attrDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form ref="attrForm" :model="attrForm" :rules="attrRules" label-width="90px">
        <el-form-item :label="`${pageTitle}名称`" prop="name">
          <el-input
            v-model="attrForm.name"
            :placeholder="`请输入${pageTitle}名称`"
            maxlength="30"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="attrForm.remark"
            type="textarea"
            :rows="3"
            maxlength="100"
            show-word-limit
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="attrForm.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="attrForm.sort" :min="0" :max="9999" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="attrDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingAttr" @click="saveAttr">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
      :title="currentAttr ? `${currentAttr.name} - 属性值` : '属性值'"
      :visible.sync="valueDrawerVisible"
      size="560px"
      custom-class="goods-meta-value-drawer"
      :wrapper-closable="false"
    >
      <div class="drawer-body">
        <div class="drawer-tools">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="openValueDialog()"
            >新增属性值</el-button
          >
        </div>
        <el-table v-loading="valueLoading" :data="valueList" size="small" border>
          <el-table-column label="编号" prop="id" align="center" width="80" />
          <el-table-column label="图标" align="center" width="90">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.valueIcon"
                class="value-icon"
                :src="scope.row.valueIcon"
                fit="cover"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="属性值" prop="valueName" align="center" min-width="130" />
          <el-table-column label="状态" prop="status" align="center" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
                {{ scope.row.status === 1 ? "启用" : "停用" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="排序" prop="sort" align="center" width="80" />
          <el-table-column label="操作" align="center" width="150">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openValueDialog(scope.row)"
                >编辑</el-button
              >
              <el-button type="danger" size="mini" plain @click="removeValue(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>

    <el-dialog
      :title="valueForm.id ? '编辑属性值' : '新增属性值'"
      :visible.sync="valueDialogVisible"
      width="460px"
      :close-on-click-modal="false"
    >
      <el-form ref="valueForm" :model="valueForm" :rules="valueRules" label-width="90px">
        <el-form-item label="属性值" prop="valueName">
          <el-input
            v-model="valueForm.valueName"
            placeholder="请输入属性值"
            maxlength="30"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="图标">
          <div class="icon-uploader" @click="$refs.valueIconInput.click()">
            <img v-if="valueForm.valueIcon" :src="valueForm.valueIcon" alt="" />
            <i v-else class="el-icon-plus"></i>
          </div>
          <input
            ref="valueIconInput"
            class="hidden-input"
            type="file"
            accept="image/*"
            @change="handleValueIconUpload"
          />
          <el-button
            v-if="valueForm.valueIcon"
            class="clear-icon-btn"
            type="text"
            @click="valueForm.valueIcon = ''"
            >清除图标</el-button
          >
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-switch v-model="valueForm.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="valueForm.sort" :min="0" :max="9999" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="valueDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingValue" @click="saveValue">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteGoodsMeta,
  deleteGoodsMetaValue,
  editGoodsMeta,
  editGoodsMetaValue,
  getGoodsMetaList,
  getGoodsMetaValueList
} from "@/api/product";
import { uploadImage } from "@/api/common";
import { formatApiDate } from "@/utils/utils";

export default {
  name: "GoodsMetaManagement",
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      attrDialogVisible: false,
      savingAttr: false,
      valueDrawerVisible: false,
      valueDialogVisible: false,
      valueLoading: false,
      savingValue: false,
      currentAttr: null,
      valueList: [],
      listQuery: {
        page: 1,
        pageSize: 20,
        name: "",
        status: null
      },
      attrForm: {
        id: null,
        name: "",
        remark: "",
        status: 1,
        sort: 0
      },
      valueForm: {
        id: null,
        attrId: null,
        valueName: "",
        valueIcon: "",
        status: 1,
        sort: 0
      },
      attrRules: {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        status: [{ required: true, message: "请选择是否启用", trigger: "change" }]
      },
      valueRules: {
        valueName: [{ required: true, message: "属性值不能为空", trigger: "blur" }],
        status: [{ required: true, message: "请选择是否启用", trigger: "change" }]
      }
    };
  },
  computed: {
    metaType() {
      return this.$route.path.indexOf("sku-management") > -1 ? 1 : 2;
    },
    pageTitle() {
      return this.metaType === 1 ? "SKU" : "商品属性";
    }
  },
  watch: {
    "$route.path"() {
      this.resetFilter();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    formatApiDate,
    getList() {
      this.listLoading = true;
      getGoodsMetaList({
        ...this.listQuery,
        type: this.metaType
      })
        .then(response => {
          const data = response.data || {};
          this.list = data.entitys || [];
          this.total = data.totalCount || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter() {
      this.listQuery = {
        page: 1,
        pageSize: 20,
        name: "",
        status: null
      };
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    openAttrDialog(row) {
      this.attrForm = row
        ? {
            id: row.id,
            name: row.name,
            remark: row.remark || "",
            status: row.status,
            sort: row.sort || 0
          }
        : {
            id: null,
            name: "",
            remark: "",
            status: 1,
            sort: 0
          };
      this.attrDialogVisible = true;
      this.$nextTick(() => this.$refs.attrForm && this.$refs.attrForm.clearValidate());
    },
    saveAttr() {
      this.$refs.attrForm.validate(valid => {
        if (!valid) return;
        this.savingAttr = true;
        editGoodsMeta({
          ...this.attrForm,
          type: this.metaType
        })
          .then(response => {
            if (response.bizcode === 100) {
              this.$message.success("保存成功");
              this.attrDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.savingAttr = false;
          });
      });
    },
    removeAttr(row) {
      this.$confirm(`确认删除「${row.name}」？`, "提示", { type: "warning" }).then(() => {
        deleteGoodsMeta({ id: row.id }).then(response => {
          if (response.bizcode === 100) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
    openValueDrawer(row) {
      this.currentAttr = row;
      this.valueDrawerVisible = true;
      this.getValueList();
    },
    getValueList() {
      if (!this.currentAttr) return;
      this.valueLoading = true;
      getGoodsMetaValueList({ attrId: this.currentAttr.id })
        .then(response => {
          this.valueList = response.data || [];
        })
        .finally(() => {
          this.valueLoading = false;
        });
    },
    openValueDialog(row) {
      this.valueForm = row
        ? {
            id: row.id,
            attrId: row.attrId,
            valueName: row.valueName,
            valueIcon: row.valueIcon || "",
            status: row.status,
            sort: row.sort || 0
          }
        : {
            id: null,
            attrId: this.currentAttr ? this.currentAttr.id : null,
            valueName: "",
            valueIcon: "",
            status: 1,
            sort: 0
          };
      this.valueDialogVisible = true;
      this.$nextTick(() => this.$refs.valueForm && this.$refs.valueForm.clearValidate());
    },
    handleValueIconUpload(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;
      if (!file.type || !file.type.startsWith("image/")) {
        this.$message.warning("请选择图片文件");
        return;
      }
      uploadImage({ file, type: "COMMON" }).then(response => {
        const data = response.data || {};
        this.valueForm.valueIcon = data.accessUrl || data.dbUrl || data.url || "";
      });
    },
    saveValue() {
      this.$refs.valueForm.validate(valid => {
        if (!valid) return;
        this.savingValue = true;
        editGoodsMetaValue(this.valueForm)
          .then(response => {
            if (response.bizcode === 100) {
              this.$message.success("保存成功");
              this.valueDialogVisible = false;
              this.getValueList();
              this.getList();
            }
          })
          .finally(() => {
            this.savingValue = false;
          });
      });
    },
    removeValue(row) {
      this.$confirm(`确认删除属性值「${row.valueName}」？`, "提示", { type: "warning" }).then(
        () => {
          deleteGoodsMetaValue({ id: row.id }).then(response => {
            if (response.bizcode === 100) {
              this.$message.success("删除成功");
              this.getValueList();
              this.getList();
            }
          });
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.goods-meta-page {
  .value-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }

  .muted {
    color: #909399;
  }

  .drawer-body {
    padding: 0 20px 20px;
  }

  .drawer-tools {
    margin-bottom: 12px;
    text-align: right;
  }

  .value-icon {
    width: 38px;
    height: 38px;
    border-radius: 6px;
  }

  .icon-uploader {
    width: 86px;
    height: 86px;
    display: grid;
    place-items: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    i {
      color: #8c939d;
      font-size: 26px;
    }
  }

  .clear-icon-btn {
    margin-left: 12px;
  }

  .hidden-input {
    display: none;
  }
}
</style>
